// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select_KoYiF","Mobile":"Mobile_eJp-W"};